<template>
  <div class="selectCustomerStyle">
    <v-autocomplete
      v-model="inputValue"
      item-text="label"
      item-value="value"
      :items="createCustomerSelectBoxValueFrom(customerList)"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      clearable
      :height="height"
      :disabled="disabled"
      :filled="disabled"
      :no-data-text="$t('common.common_no-data')"
      @input="searchInput = null"
      :search-input.sync="searchInput"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: {
    value: {
      type: Object,
      require: false,
      default: null
    },
    height: {
      type: String,
      require: false,
      default: '32px'
    },
    disabled: { default: false }
  },
  data: () => ({
    searchInput: null,
    customerList: []
  }),
  created() {
    this.init()
  },
  methods: {
    ...mapActions('Customer', ['getCustomersFromApi']),
    ...mapGetters('Customer', ['getCustomerListFromState']),
    init() {
      this.getCustomerList()
    },
    async getCustomerList() {
      await this.getCustomersFromApi({
        isHideUnusedCustomer: 1,
        isNeShop: 1
      })
      this.customerList = this.getCustomerListFromState()
    },
    createCustomerSelectBoxValueFrom(customerList) {
      if (customerList) {
        return customerList.map((ele) => {
          return {
            value: ele.customerId,
            label: ele.rep,
            neShopId: ele.neShopId,
            autoShipStorageId: ele.autoShipStorageId
          }
        })
      }
      return []
    }
  },
  computed: {
    // [変更点] selectedList は不要なため削除
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style scoped lang="scss">
/* スタイルは変更不要 */
.selectCustomerStyle {
  width: 100%;
  &::v-deep {
    .v-select__selections {
      display: flex;
      flex-wrap: nowrap;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .selectedItem {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
